<div class="relative">

    <!-- NORMAL VIEW -->
    <!-- <div class="grid lg:grid-cols-4 grid-cols-1 p-4 gap-4 w-full">
        <ng-container *ngFor="let md of data">
            <div *ngIf="md.name!='Dashboard' && md.name != 'Scarica l\'agent'"
                class="card-clickable up-on-hover cursor-pointer pb-5 m-0 w-full" (click)="view(md.route)">

                <div class="flex justify-start items-center">
                    <div class="{{md.icon || 'icon-placeholder'}} h-10 w-10 mr-2"></div>
                    <h2 class="">{{md.name}}</h2>
                </div>

            </div>


        </ng-container>



    </div> -->

    <!-- COMPACT VIEW -->
    <div class="grid lg:grid-cols-9 grid-cols-2 lg:p-4 p-2 lg:gap-4 gap-2 w-full">
        <ng-container *ngFor="let md of data">
            <div *ngIf="md.name!='Dashboard' && md.name != 'Scarica l\'agent'"
                class="flex flex-col justify-stretch items-center text-center">
                <div class="card-clickable shadow-medium rounded-3xl cursor-pointer w-full " (click)="view(md.route)">

                    <div class="flex flex-col justify-center items-center w-full h-full text-center">
                        <div class="{{md.icon || 'icon-placeholder'}} w-10/12"></div>
                    </div>

                </div>

                <p class="font-medium text-lg lg:text-xl py-2 text-colored">{{md.name}}</p>
            </div>

        </ng-container>



    </div>
</div>

<ng-container *ngIf="data.length<=0" class="w-full">
    <div class=" grid lg:grid-cols-5 grid-cols-1 text-xl p-1.5">
        <div *ngFor="let dummy of [].constructor(10)">
            <div
                class="card-clickable  shadow-medium card-small cursor-pointer justify-between flex flex-col animate-pulse ">

                <h1 class="text-3xl pb-2">-</h1>

            </div>
        </div>
    </div>

</ng-container>


<div *ngIf="stillLoading" class="flex flex-col justify-center items-center text-center">
    <button ejs-button class="dl-button" (click)="reload()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-12 h-12">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
    </button>
    <h4>Problemi nel caricamento? Ricarica la pagina </h4>
</div>